import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import { PageLink, PageLinkProps } from '../PageLink';

import * as felaRules from './PageNumberLink.rules';

export interface PageNumberLinkProps extends PageLinkProps {
    currentPage: number;
}

export const PageNumberLink = ({ currentPage, ...props }: PageNumberLinkProps) => {
    const { styles } = useFelaEnhanced(felaRules);
    const { page } = props;

    if (page === currentPage) {
        return <span className={styles.current}>{page}</span>;
    }

    return <PageLink {...props} />;
};
